import React, { Component } from 'react';
import Apng from 'react-apng';
import Toast from '../../utils/toast';
import clientApi from '../../api/client';
import './carriage.less';

import hornOff from '../../static/images/homework-new/horn_off.png';
import hornOn from '../../static/images/homework-new/play_apng.png';
import right from '../../static/images/homework-new/carriage_right.png';
import wrong from '../../static/images/homework-new/carriage_wrong.png';
import iceCream from '../../static/images/homework-new/ice_cream.png';

import carIn from '../../static/audio/car_in.mp3';
import carRight from '../../static/audio/car_right.mp3';
import carWrong from '../../static/audio/car_wrong.mp3';
import carOut from '../../static/audio/car_out.mp3';

const audioUrlList = [carIn, carRight, carWrong, carOut];

export default class Carriage extends Component {
    constructor(props) {
        super(props);
        const { questionInfo, currentIndex } = this.props;
        const question = questionInfo[currentIndex];
        const picList = [];
        this.rightIndex = Math.round(Math.random()); //正确图片所在位置
        picList[this.rightIndex] = question.correctPicture;
        picList[1 - this.rightIndex] = question.disturbPicture;
        const questionList = picList.map((item, index) => ({
            pic: item,
            key: index,
            animation: ''
        }));
        this.audioList = [];
        this.noPlayed = true; //从未播放过音频
        this.refuseChoice = false;
        this.state = {
            currentIndex: props.currentIndex, //当前题目下标
            carHeadStatus: '', //冰激淋车状态
            playing: false, //音频播放
            hideWrongItem: true, //选择错误后展示的图片
            out: '', //汽车离开动画
            question,
            questionList //问题列表
        };
        this.timeOutArr = [];
    }
    componentDidMount() {
        this.timeOutArr.push(
            setTimeout(() => {
                this.audioDuration = this.audio.duration;
                this.initAllState();
                this.audio.onerror = () => {
                    Toast.info({text:'音频加载失败，请重试'});
                //    this.audio && this.audio.load();
                }
                this.audio.onpause = () => {
                    this.noPlayed = false;
                    this.setState({
                        playing: false
                    });
                }
            }, 200)
        )
        
    }
    componentWillUnmount() {
        clearTimeout(this.CarReadyTimer);
        clearTimeout(this.nextPageTimer);
        clearTimeout(this.outTimer);
        this.timeOutArr.map(ele => (clearTimeout(ele)));
    }
    initAllState = () => {
        this.carReady(); //冰激凌车进入
        this.audio.onplaying = () => {
            this.setState({
                playing: true
            });
        };
        setTimeout(() => {
            this.playAudio();
        }, 3500);
    };
    playAudio = () => {
        this.audio && this.audio.play();
        const timeOutTime = Number(this.audioDuration) > 0 ? this.audioDuration : 3;
        clientApi.eventTracking({eventType:`c2_app_HomeWork_Car_Play`});
        this.timeOutArr.push(
            setTimeout(() => {
                this.noPlayed = false;
                this.setState({
                    playing: false
                });  
            }, Math.round(timeOutTime * 1000))
        )
    };

    pauseAudio = () => {
        this.audio && this.audio.pause();
    };

    carReady = () => {
        this.CarReadyTimer = setTimeout(() => {
            this.audioList[0].play();
            this.setState({
                carHeadStatus: 'ready'
            });
        }, 1000);
    };
    handleChoice = index => {
        if (this.noPlayed || this.refuseChoice) return;
        this.refuseChoice = true;
        if (index === this.rightIndex) {
            this.choiceRight();
        } else {
            this.choiceWrong();
        }
    };
    choiceRight = () => {
        const { questionList } = this.state;
        const newList = questionList.map((item, index) => ({
            ...item,
            animation: index === this.rightIndex ? 'move' : ''
        }));
        this.audioList[1].play();
        this.setState(
            {
                questionList: newList,
                score: 100,
            },
            () => {
                this.carOut();
            }
        );
    };
    choiceWrong = () => {
        this.audioList[2].play();
        this.setState(
            {
                hideWrongItem: false,
                score: 0,
            },
            () => {
                this.iceCream.one();
                this.nextPageTimer = setTimeout(() => {
                    this.props.nextQuestion(0);
                }, 2000);
            }
        );
    };
    carOut = () => {
        this.outTimer = setTimeout(() => {
            this.audioList[3].play();
            this.setState(
                {
                    out: 'out'
                },
                () => {
                    this.nextPageTimer = setTimeout(() => {
                        this.props.nextQuestion(1);
                    }, 2000);
                }
            );
        }, 2000);
    };
    render() {
        const {
            carHeadStatus,
            questionList,
            playing,
            hideWrongItem,
            out,
            question
        } = this.state;
        return (
            <div className="container homework_new carriage">
                {audioUrlList.map((item, index) => (
                    <audio
                        ref={dom => (this.audioList[index] = dom)}
                        key={index}
                        src={item}
                    />
                ))}
                <div className={`car-head ${carHeadStatus} ${out}`} />
                <div className="icons horn-box" onClick={()=>{ this.playAudio()}}>
                    <img
                        className={`horn horn-off ${playing ? 'hide' : ''}`}
                        src={hornOff}
                        alt="关闭"
                    />
                    <img
                        className={`horn horn-on ${playing ? '' : 'hide'}`}
                        src={hornOn}
                        alt="播放"
                    />
                    <audio
                        className="audio"
                        ref={dom => (this.audio = dom)}
                        src={question.audio}
                    />
                </div>
                {questionList.map((item, index) => (
                    <div
                        key={item.key}
                        className={`question-box question-box${index} ${
                            item.animation
                        } ${this.rightIndex === index ? out : ''}`}
                        onClick={() => {
                            this.handleChoice(index);
                        }}
                    >
                        {this.rightIndex !== index ? (
                            <Apng
                                className={`ice-cream ${
                                    hideWrongItem ? 'hide' : ''
                                }`}
                                ref={com => (this.iceCream = com)}
                                src={iceCream}
                            />
                        ) : null}
                        <div className="img-box-top" />
                        <div className="img-box">
                            <div
                                className={`section-mask ${
                                    hideWrongItem ? 'hide' : ''
                                }`}
                            >
                                {this.rightIndex === index ? (
                                    <img src={right} alt="正确" />
                                ) : (
                                    <img src={wrong} alt="正确" />
                                )}
                            </div>
                            <img
                                className="section"
                                src={item.pic}
                                alt="选项"
                            />
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/template/HomeworkNew/Carriage.jsx